import React, { useState, useEffect, useCallback } from "react";
import { Scene } from "./../../Components/Scene";
import { Canvas } from "@react-three/fiber";
import { Header } from "./../../Pages/Headers";
import { Footer } from "./../../Pages/Footer";
import { useNavigate } from "react-router-dom";
import { LoadingPage } from "../LoadingPage";

export const Planet = () => {
  const [isLoaded, setIsLoaded] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [hideLoading, setHideLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const navigate = useNavigate();

  const handleProgressUpdate = useCallback((value: number) => {
    setProgress(value);
    setShowProgressBar(value > 0);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // 设置为非加载状态
      setTimeout(() => {
        setIsLoaded(true); // 再等待过渡结束后隐藏加载屏幕
      }, 1500); // 与 CSS 过渡时间一致
    }, 3000); // 模拟加载时间为 3 秒
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading && <LoadingPage text="Loading Bera Planet" />}
      <div
        className={`page-content ${!isLoading ? "loaded app planet" : "app planet"}`}
      >
        <Header />
        {showProgressBar && (
          <div
            className={"resetProgressBar"}
            style={{
              position: "absolute",
              top: "85px",
              left: "30px",
              minWidth: "50px",
              width: "100px",
              height: "8px",
              background: "#ccc",
              overflow: "hidden",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
              zIndex: "2",
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: "100%",
                background: progress === 100 ? "#fb8500" : "#ffb703",
                transition: "width 0.1s linear",
              }}
            />
          </div>
        )}
        <Canvas
          camera={{
            position: [2, 0, 8], // 确保初始相机位置和子组件一致
            fov: 50,
          }}
        >
          <Scene
            setIsLoaded={setIsLoaded}
            onProgressUpdate={handleProgressUpdate}
          />
        </Canvas>
        <Footer />
      </div>
    </>
  );
};
